import axios from "axios";

import { basePath, createHeaders } from "./utils";

/**
 * POST
 * /api/admin/database/reset
 * 
 * Resets demo database
 */
export const resetDatabase = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .post(`${basePath}/admin/database/reset`, null, config)
      .then((resp) => {
        console.log("resetDatabase", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/admin/image/types
 * 
 * Returns all image types
 */
export const getImageTypes = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/admin/image/types`, config)
      .then((resp) => {
        console.log("getImageTypes", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/admin/image/owner/{ownerId: string($uuid)}/type/{typeId: integer($int32)}
 * 
 * Returns an optional image for owner UUID and type
 */
export const getImageByOwnerIdAndTypeId = (ownerId, typeId) => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/admin/image/owner/${ownerId}/type/${typeId}`, config)
      .then((resp) => {
        console.log("getImageByOwnerIdAndTypeId", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/admin/image/org/{orgId: string($uuid)}
 * 
 * Returns all images and logos for org
 */
export const getImagesByOrgId = (orgId) => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/admin/image/org/${orgId}`, config)
      .then((resp) => {
        console.log("getImagesByOrgId", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/admin/image/default/type/{typeId: integer($int32)}
 * 
 * Returns an optional default image for type
 */
export const getDefaultImageByTypeId = (typeId) => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/admin/image/default/type/${typeId}`, config)
      .then((resp) => {
        console.log("getDefaultImageByTypeId", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/admin/image/default/org/{orgId: string($uuid)}/type/{typeId: integer($int32)}
 * 
 * Returns an optional default image for org and type
 */
export const getDefaultImageByOrgIdAndTypeId = (orgId, typeId) => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/admin/image/default/org/${orgId}/type/${typeId}`, config)
      .then((resp) => {
        console.log("getDefaultImageByOrgIdAndTypeId", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/admin/equipment/types
 * 
 * Returns all equipment types
 */
export const getEquipmentTypes = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/admin/equipment/types`, config)
      .then((resp) => {
        console.log("getEquipmentTypes", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/admin/currency/types
 * 
 * Returns all currency types
 */
export const getCurrencyTypes = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/admin/currency/types`, config)
      .then((resp) => {
        console.log("getCurrencyTypes", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};
